import React from "react";
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
class Login extends React.Component {
  render() {
    return (
      <React.Fragment>
        <footer className="py-5">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-muted">
                  © 2022
                  <a
                    className="font-weight-bold ml-1"
                    href="https://www.stringconsultants.com/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    String Consultants
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink
                      href="https://www.pgcadd.com/about.html"
                      target="_blank"
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.pgcadd.com/contact.html"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Contact
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </React.Fragment>
    );
  }
}

export default Login;
